import { CSSProperties, ReactNode } from "react";
import { Oval } from "react-loader-spinner";
import { twMerge } from "tailwind-merge";

import { CardCornerCircles } from "./CardCornerCircles";

interface ICard {
  children?: ReactNode;
  className?: string;
  style?: CSSProperties;
  onClick?: Function;
  loading?: boolean;
  cornerCircles?: boolean;
}

export function Card({ className, style, children, onClick, loading = false, cornerCircles = false }: ICard) {
  return (
    <div
      onClick={() => {
        if (onClick) onClick();
      }}
      style={style}
      className={twMerge("bg-slate-50 border border-slate-300 rounded-lg shadow-xl p-6 ", className)}
    >
      {cornerCircles && !loading && <CardCornerCircles />}
      {loading ? <Oval color="#6137f8" width={40} /> : children}
    </div>
  );
}
